<template>
    <div>
        <div class="leftTitle mt-3 clearfix ">
            <!--Znalosti-->
            <li><span class="knowledge">{{$t("knowledge.1")}}</span>:</li>
        </div>

        <knowledge-info-set v-for="(content, i) in oContent" 
                            :key="i"    
                            :record="content"   />
    </div>
</template>

<script>
    import KnowledgeInfoSet from "@/components/KnowledgeInfoSet.vue"
    import Knowledge from "@/assets/JSON/Knowledge"
    
    export default {
        components: {
            KnowledgeInfoSet
        },
        data() {
            return {
                oContent: Knowledge
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>